export default __webpack_public_path__ + "images/0x260bbf5698121eb85e7a74f2e45e16ce762ebe11.png";